export default __webpack_public_path__ + "static/media/carouselLandscape10.cb62d5cf.jpg";